// extracted by mini-css-extract-plugin
module.exports = {"onSaleWrapper":"_1nwwe","onSale":"_14kNW","onSaleCount":"q1hvE"};